export default "__VITE_ASSET__JQ1Dokwu__"